import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CSpinner,
  CInput,
  CLabel,
  CRow,
  CTextarea,
  CInvalidFeedback,
  CSelect,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import "../../shared/css/numberFeild.css";
import { apiCall } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
// import usersData from "../users/UsersData";

const AdhocPayment = () => {
  const [lotNo, setlotNo] = useState();
  const [title, settitle] = useState();
  const [dueDate, setdueDate] = useState();
  const [terminateDate, setterminateDate] = useState();
  const [amount, setamount] = useState();
  const [purpose, setpurpose] = useState();
  const [emailIDList, setemailIDList] = useState([]);
  const [emailID, setemailID] = useState("");
  const [loading, setloading] = useState(false);
  const { authenticated } = Auth();
  const [disabledApproveRej, setdisabledApproveRej] = useState(false);

  const getEmailIdBidder = async () => {
    setloading(true);
    const header = new Headers();

    const response = await apiCall(`Bidder/getBidders`, "GET", header, null);

    const jsonobj = await response.json();

    if (response.status === 200) {
      setemailIDList(jsonobj);
    }
    setloading(false);
  };

  useEffect(() => {
    getEmailIdBidder();
    if(authenticated.role === "CGMF" && authenticated.isViewOnly)
    {
      setdisabledApproveRej(true) ;
    }
    else 
    {
      setdisabledApproveRej(false);
    }
  }, [authenticated]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setloading(true);
    const header = new Headers();
    const responseData = await apiCall(
      `LotDetails/getLotDetails?$filter=contains(lotNo,'${lotNo}') and contains(emailId,'${emailID}')`,
      "GET",
      header,
      null
    );
    const jsonobjData = await responseData.json();
    if (responseData.status === 200 && jsonobjData.length > 0) {
      header.append("Content-Type", "application/json");
      const response = await apiCall(
        "LotDetails/addadhocpayment",
        "POST",
        header,
        JSON.stringify({
          lotId: jsonobjData[0].lotId,
          lotNo: lotNo,
          tenderId: jsonobjData[0].tenderId,
          tenderNo: Number(jsonobjData[0].tenderNo),
          type: 1,
          purpose: purpose,
          dueDate,
          terminationDate: terminateDate,
          amount: parseFloat(amount),
          title,
        })
      );

      const jsonobj = await response.json();

      if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
        alert("Adjustment payment added.");
      }
    }
    setloading(false);
  };
  return (
    <>
      {loading ? (
        <CSpinner className="spinner-grow" color="success" variant="grow" />
      ) : (
        <CCardHeader className="mb-5">
          <CRow xl={12} className="pt-3">
            <CCol xl={10}>
              <h3>Adjustment Payment Details</h3>
            </CCol>
          </CRow>
          <hr />
          <CForm onSubmit={submitHandler} className="was-validation">
            <CRow className="mb-3">
              <CCol xl={2}>
                <CLabel
                  htmlFor="validationCustomselect"
                  className="col-sm-12 col-form-label"
                >
                  Email ID:
                </CLabel>
              </CCol>
              <CCol xl={3}>
                <CSelect
                  aria-label="Default select example"
                  id="validationCustomselect"
                  onChange={(e) => setemailID(e.target.value)}
                >
                  <option value="">Select Email ID</option>

                  {emailIDList.map((data, key) => (
                    <option key={key} value={data.emailId}>
                      {data.emailId}
                    </option>
                  ))}
                </CSelect>
                <CInvalidFeedback className="validationCustomselect">
                  Select Email ID.
                </CInvalidFeedback>
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xl={2}>
                <CLabel
                  htmlFor="validationCustom01"
                  className="col-sm-12 col-form-label"
                >
                  Lot number:
                </CLabel>
              </CCol>
              <CCol xl={2}>
                <CInput
                  required
                  type="text"
                  value={lotNo}
                  onChange={(e) => {
                    setlotNo(e.target.value);
                  }}
                  id="validationCustom01"
                  invalid={lotNo === "" ? true : false}
                />
                <CInvalidFeedback className="validationCustom01">
                  Please enter Lot number.
                </CInvalidFeedback>
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xl={2}>
                <CLabel
                  htmlFor="validationCustom02"
                  className="col-sm-12 col-form-label"
                >
                  Title:
                </CLabel>
              </CCol>
              <CCol xl={2}>
                <CInput
                  id="validationCustom02"
                  type="text"
                  required
                  onChange={(e) => settitle(e.target.value)}
                  invalid={title === "" ? true : false}
                />
                <CInvalidFeedback className="validationCustom02">
                  Please enter Title.
                </CInvalidFeedback>
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xl={2}>
                <CLabel htmlFor="purpose" className="col-sm-12 col-form-label">
                  Purpose:
                </CLabel>
              </CCol>
              <CCol xl={3}>
                <CTextarea
                  rows={3}
                  id="purpose"
                  onChange={(e) => setpurpose(e.target.value)}
                />
                <CInvalidFeedback className="purpose">
                  Please enter purpose.
                </CInvalidFeedback>
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xl={2}>
                <CLabel htmlFor="Amount" className="col-sm-12 col-form-label">
                  Amount:
                </CLabel>
              </CCol>
              <CCol xl={2}>
                <CInput
                  type="number"
                  id="Amount"
                  onChange={(e) => setamount(e.target.value)}
                />
                <CInvalidFeedback className="Amount">
                  Please enter Amount.
                </CInvalidFeedback>
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol xl={2}>
                <CLabel htmlFor="DueDate" className="col-sm-12 col-form-label">
                  Due Date:
                </CLabel>
              </CCol>
              <CCol xl={2}>
                <CInput
                  type="date"
                  id="DueDate"
                  onChange={(e) => setdueDate(e.target.value)}
                />
                <CInvalidFeedback className="DueDate">
                  Please enter Due Date.
                </CInvalidFeedback>
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xl={2}>
                <CLabel
                  htmlFor="TerminateDate"
                  className="col-sm-12 col-form-label"
                >
                  Date of Termination:
                </CLabel>
              </CCol>
              <CCol xl={2}>
                <CInput
                  type="date"
                  id="TerminateDate"
                  onChange={(e) => setterminateDate(e.target.value)}
                />
                <CInvalidFeedback className="TerminateDate">
                  Please enter Terminate Date.
                </CInvalidFeedback>
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xl={2}>
                <CButton className="" disabled={disabledApproveRej} type="submit" color="success">
                  Add
                </CButton>
                <CButton className="ml-3" type="reset" color="danger">
                  Cancel
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </CCardHeader>
      )}
    </>
  );
};
export default AdhocPayment;
